<template>
  <div :class="[baseCss]">
    <card :overflow-off="false" :bg-color="bgColor" :bg-color-lightness="bgColorLightness">
      <card-text>
        <flex :spacing="3">
          <flex-col :span="12" sm24>
            <dropdown :icon="icons ? 'counter' : null" :title="lang.length" :label-color="labelColor" :label-color-lightness="labelColorLightness" :color="color" :color-lightness="colorLightness" v-model="length" :items="lengths" :label="lang.length" />
          </flex-col>
          <flex-col :span="12" sm24>
            <dropdown :icon="icons ? 'alpha' : null" :title="lang.options" :label-color="labelColor" :label-color-lightness="labelColorLightness" :color="color" :color-lightness="colorLightness" v-model="options" :items="items" :multiple="true" :label="lang.options" />
          </flex-col>
        </flex>
      </card-text>
      <divider />
      <card-actions align="left">
        <flex :spacing="3">
          <flex-col :span="16" sm24>
            <text-field @focus="select" :icon-left="icons ? 'lock' : null" v-model="password" :readonly="true" :color="color" :color-lightness="colorLightness" />
          </flex-col>
          <flex-col :span="4" sm12>
            <btn :class="['mt-2']" :icon-left="icons ? 'content-copy' : null" :block="true" @click="copy" :disabled="!options.length || !password.length" size="sm" :color="buttonLabelColor" :color-lightness="buttonLabelColorLightness" :bg-color="color" :bg-color-lightness="colorLightness" :title="lang.copy">{{ lang.copy }}</btn>
          </flex-col>
          <flex-col :span="4" sm12>
            <btn :class="['mt-2']" :icon-left="icons ? 'creation' : null" :block="true" @click="generate" :disabled="!options.length" size="sm" :color="buttonLabelColor" :color-lightness="buttonLabelColorLightness" :bg-color="color" :bg-color-lightness="colorLightness" :title="lang.generate">{{ lang.generate }}</btn>
          </flex-col>
        </flex>
      </card-actions>
    </card>
  </div>
</template>
<script>
import methods from '../../mixins/methods'
const options = [
  'symbol',
  'number',
  'lowerCase',
  'upperCase'
]

/* eslint-disable no-useless-escape */
export default {
  name: 'PasswordGenerator',
  mixins: [
    methods
  ],
  data () {
    return {
      options,
      password: '',
      length: [16],
      lengths: [8, 16, 32, 64, 128, 256, 516, 1024].map(value => {
        return {
          value,
          text: value
        }
      }),
      keys: {
        upperCase: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
        lowerCase: 'abcdefghijklmnopqrstuvwxyz',
        number: '0123456789',
        symbol: '!@#$%^&*()_+~\`|}{[]:;?><,./-='
      },
      items: options.sort().map(value => {
        return {
          value,
          text: this.firstLetterCapital(value.toLowerCase())
        }
      }),
      baseCss: this.componentBaseCss('password-generator', [])
    }
  },
  props: {
    autoGenerate: {
      type: Boolean,
      default: true
    },
    icons: {
      type: Boolean,
      default: true
    },
    color: {
      type: String
    },
    colorLightness: {
      type: Number
    },
    labelColor: {
      type: String
    },
    labelColorLightness: {
      type: [String, Number]
    },
    buttonLabelColor: {
      type: String
    },
    buttonLabelColorLightness: {
      type: Number
    },
    bgColor: {
      type: String
    },
    bgColorLightness: {
      type: Number
    },
    lang: {
      type: Object,
      default: () => {
        return {
          length: 'Length',
          options: 'Options',
          generate: 'Generate',
          copy: 'Copy'
        }
      }
    }
  },
  computed: {
    getKey () {
      const getRandomKey = (key) => {
        const keys = this.keys
        return keys[key][Math.floor(Math.random() * keys[key].length)]
      }
      return [
        function upperCase () {
          return {
            name: 'upperCase',
            fn: getRandomKey('upperCase')
          }
        },
        function lowerCase () {
          return {
            name: 'lowerCase',
            fn: getRandomKey('lowerCase')
          }
        },
        function number () {
          return {
            name: 'number',
            fn: getRandomKey('number')
          }
        },
        function symbol () {
          return {
            name: 'symbol',
            fn: getRandomKey('symbol')
          }
        }
      ]
    }
  },
  mounted () {
    if (this.autoGenerate) {
      this.generate()
    }
  },
  methods: {
    generate () {
      let password = []
      for (let i = 0; i < this.length[0]; i++) {
        const key = this.getKey[Math.floor(Math.random() * this.getKey.length)]
        if (this.options.includes(key().name)) {
          password.push(key().fn)
        }
      }
      this.password = password.join('')
      this.$emit('change', {
        output: this.password,
        length: this.length[0],
        options: this.options
      })
    },
    select () {
      this.getInput().select()
    },
    getInput () {
      return this.$el.querySelector('input[type="text"]')
    },
    copy () {
      this.select()
      document.execCommand('copy')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/password-generator/password-generator.vue